import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import ErrorContainer from "../../../Components/ErrorContainer";
import BuyAssets from "./BuyAssets";
import { getFormData } from "../../../../helpers";
import OutstandingInvoices from "./OutstandingInvoices";

const OtherDebt = () => {
  return (
    <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
      <h4 className="event-alert w-100 mb-0">Other Debt</h4>
      <div className="row col-12 mx-0">
        <table className="checklist-table remove-space inventory_table">
          <thead>
            <tr>
              <th> Account </th>
              <th>Date/Time</th>
              <th>Invoice ID</th>
              <th>Description</th>
              <th>O/S Amount </th>
              <th>Use Now </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
};

export default OtherDebt;
